import { useState } from 'react'
import { Modal } from 'antd'
import { removeElem } from 'Services/WeaverUtils'
import ReactDOM from 'react-dom'
import LogContent from './LogContent'

export default function showLoggerModal (orchestrator, uid) {

  const modalContainer = document.createElement('div')
  document.body.append(modalContainer)

  const LoggerModal = ({ uid, container, orchestrator }) => {
    const [visible, setVisible] = useState(true)

    return (
      <Modal
        visible={visible}
        closable={true}
        destroyOnClose={true}
        afterClose={() => removeElem(container)}
        onCancel={() => setVisible(false)}
        footer={null}
        width={Math.max(500, window.innerWidth * .8)}
        title={<h4>Logs</h4>}
        centered={true}
      >
        <LogContent
          uid={uid}
          orchestrator={orchestrator}
        />
      </Modal>
    )
  }

  ReactDOM.render(
    <LoggerModal
      uid={uid}
      orchestrator={orchestrator}
      container={modalContainer}
    />
  , modalContainer)
}
